import { abortableFetch, useEventCallback } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useDeleteDispatchDialog() {
  const callApi = useEventCallback((dispatchId: string) => {
    return abortableFetch(
      `${EvidenceApiUrl.DOCUMENTS_DISPATCHES}/${dispatchId}`,
      {
        method: 'DELETE',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
  });

  return {
    callApi,
  };
}
